<template>
  <div>
    <!--  -->

    <BTextarea
      v-model="form.name"
      rows="1"
      :disabled="disabled"
      validate="required"
      label="Название"
      class="mt-4"
      name="name"
      autofocus
    />

    <v-row dense class="mb-2">
      <v-col>
        <BTextField
          v-model.number="form.max_file_count"
          :disabled="disabled"
          validate="numeric|min_value:0"
          label="Кол-во прикрепляемых файлов"
          type="number"
          class="mt-4"
          name="max_file_count"
        />
      </v-col>

      <v-col>
        <BTextField
          v-model.number="form.max_file_size"
          :disabled="disabled"
          validate="numeric|min_value:0"
          label="Максимальный размер файла"
          type="number"
          suffix="Mb"
          class="mt-4"
          name="max_file_size"
        />
      </v-col>
    </v-row>

    <BTextarea
      v-model="form.description"
      rows="3"
      label="Описание"
      :disabled="disabled"
      name="description"
      class="mb-3"
    />

    <BAutocompleteCommon
      v-model="form.file_types"
      :readonly="disabled"
      validate="required"
      $type="file-type"
      multiple
      small-chips
      name="file_types"
    />

    <!--  -->
  </div>
</template>

<script>
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'

export const createDefaultData = () => ({
  // id
  name: '',
  description: '',
  file_types: [],
  max_file_size: 10,
  max_file_count: 1,
  base_event_files: [],
  // created_at
  // updated_at
})

export default {
  name: 'RoadmapBaseEventsForm',
  components: {
    BTextField,
    BTextarea,
    BAutocompleteCommon,
  },
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>
